const routes = [
    // 外教员工管理路由
    {
      path: "/foreignStaff",
      name: "foreignStaff",
      meta: {
        title: "员工管理",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignStaff/index.vue")
    },
  ];
  export default routes;